
import React, { useEffect, useLayoutEffect, useState } from 'react';
import {ShowPopupFirstTime} from './ShowPopupFirstTime';

const ParentComponentTnc = ({ userEmail, updateTermAndConditionAcceptenceFn, isTermAcceptedFirstTime=true, isTermAcceptedFirstTimeIsLoading }) => {
    // console.log("🚀 ~ ParentComponentTnc ~ isTermAcceptedFirstTime:", isTermAcceptedFirstTime)
    // const [dialogOpenTncFirstTime, setDialogOpenTncFirstTime] = useState(false);
    // isTermAcceptedFirstTime = false
    // Automatically open dialog if terms are not accepted
    // useEffect(() => {
    //     // if(isTermAcceptedFirstTimeIsLoading){
    //         if (isTermAcceptedFirstTime) {
    //             // dialogOpenTncFirstTime = true
    //             setDialogOpenTncFirstTime(false);
    //         }
    //     // }
    // }, [isTermAcceptedFirstTime]);

    const valuehold = !isTermAcceptedFirstTime
    return (
        
            // !isTermAcceptedFirstTime && (
                <ShowPopupFirstTime 
                    dialogOpenTnc={valuehold}
                    setDialogOpenTnc={valuehold}
                    userEmail={userEmail}
                    updateTermAndConditionAcceptenceFn={updateTermAndConditionAcceptenceFn}
                    isTermAcceptedFirstTime={isTermAcceptedFirstTime}
                />
            // )
        
    );
};

export default ParentComponentTnc